/**
 * Module that exports a pusher instance to save code duplication and it's more configurable globally
 */

import config from '../../config'
import Pusher from 'pusher-js'

let pusher = new Pusher(config.PusherKey, {
  cluster: "mt1",
  encrypted: true,
});

Pusher.logToConsole = process.env.NODE_ENV === 'development';
export default pusher;



// WEBPACK FOOTER //
// ./src/helpers/PusherManager/index.js